import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast
} from "@chakra-ui/react";
import { t } from "i18next";
import { hideAppSpinner } from "../../../../../../context/Store/slices/appSpinnerSlice";
import { useGetSupplierQuestionnaireById } from "../../../../../../hooks/query";
import { showErrorToast } from "../../../../../../utils";
import { useDispatch } from "react-redux";
import React from "react";
import { SUPPLIER_QUESTIONNAIRE_CATEGORIES } from "../../../../../SupplierQuestionnaire/helpers";
import { MissingCategory, RevenueModalBody } from "./index";
import { Location } from "../../../../../SupplierQuestionnaire/components/Location";
import { Product } from "../../../../../SupplierQuestionnaire/components/Product";
import { useAuth } from "../../../../../../context";
import { DecarbonizationNetZeroPlan } from "../../../../../SupplierQuestionnaire/components/DecarbonizationNetZeroPlan";

function SuppliersDataModal({ isOpen, onClose, questionnaireId }) {
  const toast = useToast();
  const dispatch = useDispatch();

  const { user } = useAuth();
  const assignee = {
    name: user.name,
    avatarUrl: user.picture
  };

  const {
    data,
    isFetching
  } = useGetSupplierQuestionnaireById(questionnaireId, {
    enabled: questionnaireId !== "" && questionnaireId !== null,
    onError: err => showErrorToast(toast, err.message),
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0
  });

  const renderModalBodyByCategory = (category) => {
    switch (category) {
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.REVENUE:
        return <RevenueModalBody data={{...data, ...data.revenue}} isOpen={isOpen} />;
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.PRODUCT:
        return <Product assignee={assignee} data={data} isPreview={true} />;
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.LOCATION:
        return <Location assignee={assignee} data={data} isPreview={true} />;
      case "DECARBONIZATION":
        return <DecarbonizationNetZeroPlan data={data} isPreview={true} />
      default:
        return <MissingCategory assignee={assignee} data={data} />;
    }
  };

  return (
    !isFetching && data ? <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("reportsPage.suppliersData.modal.title")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {renderModalBodyByCategory(data.category)}
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("reportsPage.suppliersData.modal.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal> : null
  );
}

export default SuppliersDataModal;